import React from 'react';
import { Skeleton } from 'antd';
import { Card, Text } from '@clockout-dev/design-elements';
import UserSummaryTable from './UserSummaryTable';
import styles from './styles/user-summary-section.module.scss';

function UserSummarySection({ rows = [], loading = false, pageInfo = null, onTableChange }) {
    return (
        <section className={styles.section}>
            <Text as="span" size="xs" className={styles.sectionLabel}>User Summary</Text>
            <Card className={styles.card}>
                {loading ? (
                    <Skeleton active paragraph={{ rows: 8 }} />
                ) : (
                    <UserSummaryTable
                        rows={rows}
                        loading={false}
                        pageInfo={pageInfo}
                        onTableChange={onTableChange}
                    />
                )}
            </Card>
        </section>
    );
}

export default UserSummarySection;
